import { Typography, Container } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

const useStyles = makeStyles((theme) => ({
    drawer: {
        '& .MuiDrawer-paper': {
            backgroundColor: '#fbfbfd',
            '@media (max-width:768px)': {
                width: '100%',
            },
        },
    },
    roleReceiver: {
        backgroundColor: theme?.palette?.background?.paper,
        padding: '1.6rem 3.2rem',
        textTransform: 'uppercase',
        boxShadow: ' 0 0.4rem 1.7rem 0 rgba(0, 0, 0, 0.07)',

        '@media (max-width:768px)': {
            padding: '1.6rem 1.6rem',
        },
    },
    roleReceiverDivider: {
        height: '0.1rem',
        backgroundColor: '#d8d8dd;',
    },
    lineManagerContainer: {
        background: theme?.palette?.background?.paper,
        width: '100%',
        borderTop: '0.1rem solid #d8d8dd',
        boxShadow: ' 0 0.4rem 1.7rem 0 rgba(0, 0, 0, 0.07)',
    },
    lineManager: {
        background: theme?.palette?.background?.paper,
        padding: '2.4rem 3rem',
        maxWidth: '48rem',

        '@media (max-width:768px)': {
            padding: '1.2rem 1.6rem',
        },
    },
    box: {
        padding: '2.5rem 3rem',
        backgroundColor: '#fbfbfd',
        width: '100%',
        borderTop: '0.1rem solid #d8d8dd',
        boxShadow: ' 0 0.4rem 1.7rem 0 rgba(0, 0, 0, 0.07)',

        '@media (max-width:768px)': {
            padding: '2.5rem 1.6rem',
        },
    },
    formContainer: {
        display: 'flex',

        '@media (max-width:768px)': {
            flexDirection: 'column',
        },
    },
    requestName: {
        flex: 0.75,
        paddingRight: '0.8rem',

        '@media (max-width:768px)': {
            paddingRight: 0,
        },
    },
    dueDate: {
        flex: 0.25,
        paddingLeft: '0.8rem',

        '@media (max-width:768px)': {
            paddingLeft: 0,
            maxWidth: '20rem',
        },
    },
    cartComment: {
        marginTop: '0.8rem',

        '@media (max-width:768px)': {
            flexDirection: 'column',
            marginTop: '2.4rem',
        },
    },
}))

const MyContainer = withStyles({
    root: {
        backgroundColor: '#fbfbfd',
        padding: '0.8rem 3.2rem',

        '@media (max-width:768px)': {
            padding: '0.8rem 1.6rem',
        },
    },
})(Container)

const MyTypography = withStyles((theme) => ({
    root: { overflowWrap: 'anywhere' },
    h1: {
        color: theme?.palette?.common?.black,
        fontSize: '2.4rem',
        padding: '1.4rem 3rem 0.9rem 3rem',
        fontWeight: 'normal',
    },
    h2: {
        fontSize: '5rem',
        '& span': {
            width: '33rem',
            display: 'inline-block',
        },
        '& b': {
            fontWeight: '700',
        },
    },
    h3: {
        fontSize: '1.8rem',
        fontWeight: '500',
        color: theme?.palette?.common?.white,
    },
    h5: {
        fontSize: '3rem',
    },

    caption: {
        fontSize: '1.6rem',
        fontWeight: 'normal',
        color: '#8a8989',
    },
}))(Typography)

const useCartItemStyles = makeStyles((theme) => ({
    cartItem: {
        margin: '3.6rem 0',
        position: 'relative',
        overflow: 'visible',
        borderRadius: '0.8rem !important',
        boxShadow: '0 0.4rem 1.6rem 0 rgba(0, 0, 0, 0.05) !important',
    },
    borderBox: {
        borderImageSource:
            'linear-gradient(to right, rgba(1, 174, 143, 0), #04ab93 7%, #2c83bd 91%, rgba(48, 127, 193, 0)) !important',
        borderImageSlice: `${1} !important`,
        borderBottom: '0.1rem solid !important',
        opacity: '0.25',
    },
    riskBorderBox: {
        borderImageSource:
            'linear-gradient(to right, rgba(208, 2, 27, 0), #d0021b 8%, #d00238 91%, rgba(208, 2, 69, 0)) !important',
        borderImageSlice: `${1} !important`,
        borderBottom: '0.1rem solid !important',
        opacity: '0.25',
    },

    cartItemHeader: ({ bgColor }) => ({
        background: bgColor,
        padding: '1.6rem',
        position: 'relative',
        borderTopLeftRadius: '0.8rem',
        borderTopRightRadius: '0.8rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& svg.delete': {
            color: theme?.palette?.error?.main,
        },
    }),
    deleteIconContainer: {
        backgroundColor: '#faf7f6',
        borderRadius: '0.8rem',
        height: '3.2rem',
        width: '3.2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#d8d8dd',
        },
    },
    itemLabel: {
        position: 'absolute',
        top: '-1.4rem',
        display: 'flex',

        '@media (max-width:768px)': {
            left: '-0.8rem',
        },
    },

    addOrRemoveLabel: ({ assignmentType }) => ({
        backgroundImage:
            assignmentType === 'Add'
                ? 'linear-gradient(101deg, ' +
                  theme?.palette?.secondary?.main +
                  ', #30c17c)'
                : 'linear-gradient(102deg, #ae0142, #c14830)',
        borderRadius: '0.5rem',
        padding: '0.2rem 0.8rem',
        textTransform: 'uppercase',
        color: theme?.palette?.common?.white,
        fontSize: '1.2rem',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
    }),
    resourceTypeLabel: {
        marginLeft: '2rem',
        backgroundColor: theme?.palette?.background?.paper,
        borderRadius: '0.5rem',
        border: '0.1rem solid #aab0b4',
        padding: '0.2rem 0.8rem',
        textTransform: 'uppercase',
        color: '#3b454d',
        fontSize: '1.2rem',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
    },
    cartItemContent: {
        padding: '1.6rem 1.6rem',
    },
    cartCommentContainer: {
        display: 'flex',
        marginBottom: '1rem',

        '@media (max-width:660px)': {
            flexDirection: 'column',
        },
    },
    cartComment: {
        flex: 0.75,
        marginTop: '-0.8rem',
    },
    timeConstraints: {
        flex: 0.25,
        marginLeft: '1.6rem',
        marginRight: '1.6rem',

        '@media (max-width:660px)': {
            marginLeft: 0,
            marginRight: 0,
        },
    },
    moreAttributes: {
        '@media (max-width:660px)': {
            marginTop: '0.8rem',
        },
    },

    horizontalOrVertical: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        '& > div:last-child': {
            marginLeft: '1.6rem',
        },

        '@media (max-width:660px)': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            '& > div:last-child': {
                marginLeft: 0,
            },
        },
    },
    additionalField: {
        display: 'flex',
        flexDirection: 'column',
    },
    additionalFieldWrapper:{
        padding:'0 1.6rem',
    },
    fieldHeaderTitle: {
        background:
            'repeating-linear-gradient(#fff, #fff 3px, rgba(0, 0, 0, 0.02) 3px, rgba(0, 0, 0, 0.02) 4px)',
        display: 'flex',
        justifyContent: 'space-between',
        borderBottom: '0.1rem solid #efeff1',
        padding:'0 1.6rem'

    },
    expandButton: {
        textTransform: 'uppercase',
        zIndex: 9999,
        marginTop: '0.2rem',
        color: '#307fc1',
        fontSize:'1.2rem',
        '&:hover': {
            cursor: 'pointer',
        },
    },
    expandIcon: {
        width: '1.8rem',
        height: '1.8rem',
        marginLeft: '0.8rem',
        marginTop: '-0.2rem',
        borderRadius: '50%',
        border: `0.1rem solid ${theme?.palette?.primary?.main}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: theme?.palette?.primary?.main,
        lineHeight:'0',
        fontSize:'1.5rem'

    },
    cartItemContentWithFieldTypes: {
        paddingBottom: '0 !important',
        paddingLeft:'0 !important',
        paddingRight:'0 !important',
    },
    cartCommentContainerFieldType:{
        padding:'0 1.6rem !important',
    },
    fieldTypeAttribute: {
        '& div': {
            fontSize: '1.4rem',
            fontWeight: '600',
            color: theme?.palette?.common?.black,
        },
    },
    darkBg: {
        marginLeft: '-1rem',
        background: '#3b454d',
        color: theme?.palette?.common?.white,
        borderColor:  '#3b454d',
        zIndex:'9',
        paddingLeft:'2rem',
    }
}))

const useShowMoreButtonStyles = makeStyles((theme) => ({
    root: {
        position: 'absolute',
        bottom: '0',
        right: '0.5rem',
        minWidth: '12rem',
        minHeight: '3.2rem',
        backgroundColor: theme?.palette?.background?.paper,
        boxShadow: '0 0.2rem 1.6rem 0 rgba(0, 0, 0, 0.11)',
        color: theme?.palette?.primary?.main,
        textTransform: 'uppercase !important',
        borderRadius: '1.6rem',
        fontSize: '1.1rem',
        lineHeight: '1.45',
        '&:hover': {
            backgroundColor: theme?.palette?.background?.paper,
            color: theme?.palette?.primary?.main,
            '& span': {
                color: theme?.palette?.primary?.main,
            },
        },
    },
}))

export {
    useStyles,
    MyContainer,
    MyTypography,
    useCartItemStyles,
    useShowMoreButtonStyles,
}
